module.exports = __webpack_public_path__ + "static/media/90.85632d08.jpeg";